import clsx from 'clsx'
import React from 'react'

import { sanitizeAndProcessHtml } from '@/_lib/dom-purify.utils'

export enum LIST_STYLE_ENUM {
	ORDERED = 'ordered',
	UNORDERED = 'unordered'
}

export interface ListItem {
	content: string
	items: ListItem[]
}

export interface NestedListData {
	items: ListItem[]
	style: LIST_STYLE_ENUM
}

export interface BEditorJsNestedListProps {
	data: NestedListData
}

export const BEditorJsNestedList: React.FC<BEditorJsNestedListProps> = ({ data }) => {
	const { items, style } = data

	const renderNestedList = (listItems: ListItem[], listStyle: LIST_STYLE_ENUM) => {
		const ListComponent = listStyle === LIST_STYLE_ENUM.ORDERED ? 'ol' : 'ul'

		// const sharedClasses = 'mb-8 text-[#4A337A] list-inside'
		// const listClasses =
		// 	listStyle === 'ordered' ? `${sharedClasses} list-decimal` : `${sharedClasses} list-disc`

		return (
			// <ListComponent className={listClasses}>
			// 	{listItems.map((item, index) => (
			// 		<li key={index} className='mb-2 text-[#4A337A]'>
			// 			<span dangerouslySetInnerHTML={{ __html: item.content }} />
			// 			{item.items && item.items.length > 0 && (
			// 				<div className='pl-4'>{renderNestedList(item.items, listStyle)}</div>
			// 			)}
			// 		</li>
			// 	))}
			// </ListComponent>

			<ListComponent
				className={clsx('editorjs-renderer_list', {
					'editorjs-renderer_list_ordered': listStyle === LIST_STYLE_ENUM.ORDERED,
					'editorjs-renderer_list_unordered': listStyle === LIST_STYLE_ENUM.UNORDERED
				})}
			>
				{listItems.map((item, index) => (
					<li key={index}>
						<span
							suppressHydrationWarning
							dangerouslySetInnerHTML={{
								__html: sanitizeAndProcessHtml(item.content)
							}}
						/>

						{item.items && item.items.length > 0 && (
							<div className='editorjs-renderer_nested-list'>
								{renderNestedList(item.items, listStyle)}
							</div>
						)}
					</li>
				))}
			</ListComponent>
		)
	}

	return <div className='editorjs-renderer_block'>{renderNestedList(items, style)}</div>
}

export default BEditorJsNestedList
